'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { Fragment, memo } from 'react';
import ReportWithVisualization from './ReportWithVisualization';
import ReportErrored from './states/ReportErrored';
import ReportLoading from './states/ReportLoading';
import { Metrics } from '../../../monitoring/Metrics';
import { RENDERED_NO_DATA, NO_DATA_TYPES } from '../../../constants/trackingMetrics';
import NoData from '../../../components/shared/NoData';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ReportWithData = ({
  report,
  reportLoading,
  configuredReport,
  reportData,
  reportHasData,
  reportError,
  disableEmptyStates,
  paginationRenderer,
  noDataRenderer,
  errorRenderer,
  visualizationDebug,
  determineVisualization,
  gates,
  isMobile,
  visualize,
  refreshReportData,
  compact,
  mobileReportingOptions,
  disableZoom
}) => {
  if (reportLoading) {
    return /*#__PURE__*/_jsx(ReportLoading, {});
  }
  const rhumbConfig = report.getIn(['displayParams', 'rhumbConfig'], ImmutableMap());
  const renderSuccessMarker = rhumbConfig.get('renderSuccessMarker');
  const renderErrorMarker = rhumbConfig.get('renderErrorMarker');
  if (reportError) {
    if (errorRenderer) {
      return errorRenderer(reportError, report);
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ReportErrored, {
        error: reportError,
        isMobile: isMobile
      }), renderErrorMarker && renderErrorMarker()]
    });
  }
  if (!disableEmptyStates && !reportHasData) {
    Metrics.counter(RENDERED_NO_DATA, {
      type: noDataRenderer ? NO_DATA_TYPES.CUSTOM : NO_DATA_TYPES.STANDARD
    }).increment();
    return noDataRenderer ? noDataRenderer() : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        flexGrow: 1,
        "data-status-id": "report-status-loaded",
        "data-test-id": "reporting-visualization-report",
        children: /*#__PURE__*/_jsx(NoData, {
          isMobile: isMobile,
          visualizationDebug: visualizationDebug
        })
      }), renderSuccessMarker && renderSuccessMarker()]
    });
  }
  if (visualize) {
    // Report-plugin visualization
    return visualize(report, reportData, isMobile, refreshReportData);
  }
  return /*#__PURE__*/_jsx(ReportWithVisualization, {
    compact: compact,
    report: configuredReport,
    data: reportData,
    paginationRenderer: paginationRenderer,
    visualizationDebug: visualizationDebug,
    determineVisualization: determineVisualization,
    gates: gates,
    isMobile: isMobile,
    mobileReportingOptions: mobileReportingOptions,
    disableZoom: disableZoom
  });
};
ReportWithData.propTypes = {
  report: PropTypes.object.isRequired,
  reportLoading: PropTypes.bool.isRequired,
  configuredReport: PropTypes.object,
  refreshReportData: PropTypes.func,
  reportData: PropTypes.object,
  reportHasData: PropTypes.bool,
  reportError: PropTypes.object,
  disableEmptyStates: PropTypes.bool,
  paginationRenderer: PropTypes.func,
  noDataRenderer: PropTypes.func,
  errorRenderer: PropTypes.func,
  determineVisualization: PropTypes.func,
  gates: PropTypes.array,
  isMobile: PropTypes.bool,
  compact: PropTypes.bool,
  /* For debugging v2 visualizations */
  visualizationDebug: PropTypes.object,
  visualize: PropTypes.func,
  mobileReportingOptions: PropTypes.object,
  disableZoom: PropTypes.bool
};
export default /*#__PURE__*/memo(ReportWithData);